import type { MomentumUser } from '../../shared/models/momentum-user.models';
import type { UserInformation } from '../../shared/users/models/user-information.models';

export const MOCK_DIRECTORY_USERS: readonly MomentumUser[] = [
  {
    oId: '11111111-1111-1111-1111-111111111101',
    name: 'Alex Persona',
    email: 'mock.persona@zuehlke.com',
  },
  {
    oId: '11111111-1111-1111-1111-111111111102',
    name: 'Blake Personb',
    email: 'mock.personb@zuehlke.com',
  },
  {
    oId: '11111111-1111-1111-1111-111111111103',
    name: 'Casey Personc',
    email: 'mock.personc@zuehlke.com',
  },
  {
    oId: '11111111-1111-1111-1111-111111111104',
    name: 'Dana Persond',
    email: 'mock.persond@zuehlke.com',
  },
  {
    oId: '11111111-1111-1111-1111-111111111105',
    name: 'Eden Persone',
    email: 'mock.persone@zuehlke.com',
  },
  {
    oId: '11111111-1111-1111-1111-111111111106',
    name: 'Finley Personf',
    email: 'mock.personf@zuehlke.com',
  },
  {
    oId: '11111111-1111-1111-1111-111111111107',
    name: 'Marketing Team',
    email: 'marketing@zuehlke.com',
  },
];

/** Directory users who are in Entra but not yet in RBAC_Momentum-Users. */
const MOCK_NON_MOMENTUM_USER_OIDS = new Set<string>(['11111111-1111-1111-1111-111111111107']);

const USERS_BY_EMAIL = new Map<string, MomentumUser>();
const USERS_BY_OID = new Map<string, MomentumUser>();

for (const user of MOCK_DIRECTORY_USERS) {
  if (user.email) {
    USERS_BY_EMAIL.set(user.email.toLowerCase(), user);
  }
  if (user.oId) {
    USERS_BY_OID.set(user.oId, user);
  }
}

export function mockDirectoryUserByEmail(
  email: string | null | undefined,
): MomentumUser | undefined {
  const key = email?.trim().toLowerCase();
  if (!key) {
    return undefined;
  }
  return USERS_BY_EMAIL.get(key);
}

export function mockDirectoryUserByOId(oId: string | null | undefined): MomentumUser | undefined {
  const key = oId?.trim();
  if (!key) {
    return undefined;
  }
  return USERS_BY_OID.get(key);
}

export function mockMomentumUserFromOId(oId: string | null | undefined): MomentumUser | null {
  const key = oId?.trim();
  if (!key) {
    return null;
  }

  return mockDirectoryUserByOId(key) ?? { oId: key };
}

export function mockCatalogUserFromEmail(email: string | null | undefined): MomentumUser {
  return mockDirectoryUserByEmail(email) ?? (email?.trim() ? { email: email.trim() } : {});
}

export function searchMockDirectoryUsers(search: string, limit: number): MomentumUser[] {
  const query = search.trim();
  if (query.length < 2) {
    return [];
  }

  return MOCK_DIRECTORY_USERS.filter(
    (user) =>
      (user.name?.toLowerCase().includes(query.toLowerCase()) ?? false) ||
      (user.email?.toLowerCase().includes(query.toLowerCase()) ?? false),
  ).slice(0, Math.max(1, Math.min(limit, 50)));
}

export function mockUserInformation(oId: string | null | undefined): UserInformation | null {
  const key = oId?.trim();
  if (!key) {
    return null;
  }

  return {
    oId: key,
    isMomentumUser: !MOCK_NON_MOMENTUM_USER_OIDS.has(key),
  };
}
